import React from "react";
import Highcharts from "highcharts";
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsReact from "highcharts-react-official";
if (typeof Highcharts === 'object') {
  HighchartsExporting(Highcharts)
}
class LineChart extends React.Component {
  render() {
    const items = this.props.datos;
    const chartOptions = {
      chart: {
        type: "line"
      },
      title: {
        text: this.props.title || "Line Chart Title"
      },
      xAxis: {
        categories: this.props.category || [],
        labels: {
          rotation: -45,
          style: {
            fontSize: "13px",
            fontFamily: "Verdana, sans-serif"
          }
        }
      },
      yAxis: {
        title: {
          text: this.props.titley
        }
      },
      tooltip: {
        headerFormat:
          'Denuncias registradas en <span  style="color:{point.color}">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y}</b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true
      },
      series: items,
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: true
        }
      },
      credits: {
        enabled: false
      },
      lang: {
        noData: "No hay datos para mostrar" //the text to be displayed
      },
      noData: {
        position: {
          x: 0,
          y: 0,
          align: "center",
          verticalAlign: "middle"
        }
      },
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [{
              text: "Imprimir",
              textKey: 'printChart',
              onclick: function () {
                this.print();
              }
            }, {
              text: "Descargar como PNG",
              textKey: 'downloadPNG',
              onclick: function () {
                this.exportChart();
              }
            }, {
              text: "Descargar como JPEG",
              textKey: 'downloadJPEG',
              onclick: function () {
                this.exportChart({
                  type: 'image/jpeg'
                });
              }
            }, {
              text: "Descargar como PDF",
              textKey: 'downloadPDF',
              onclick: function () {
                this.exportChart({
                  type: 'application/pdf'
                });
              }
            }]
          }
        }
      }
    };
    return (
      <div>
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </div>
    );
  }
}

export default LineChart;
